import DocumentIcon from '../../assets/images/DocumentIcon.svg';
import Spinner from '../../assets/images/Spinner.svg';

import { IFileAssets } from './IFileAssets.js';
/* [AddAsset: import] */

export const fileAssets: IFileAssets = {
	documentTile: {
		icon: DocumentIcon,
		spinner: Spinner,
		/* [AddAsset: documentTile] */
	},
	/* [InitComponentAsset: assetKey] */
};
